export default "__VITE_ASSET__ChPSvxiw__"